// TOP LEVEL IMPORTS
import React from 'react';
import windowSize from 'react-window-size';
import styled from 'styled-components';
// COMPONENTS
import NoStudioModal from './NoStudioModal';
import Icon from 'components/common/Icon';
import EmailTemplatesArea from './EmailTemplatesArea';
import SessionTypesArea from './SessionTypesArea';
import StudioFormArea from './StudioFormArea';
import ContactSettingsArea from './ContactSettingsArea';
import IntegrationsArea from './IntegrationsArea';
import QuestionTemplatesArea from './QuestionTemplatesArea';
import PaymentsArea from './PaymentsArea';
import InviteArea from './InviteArea';
import PricingAndPackagingArea from './PricingAndPackagingArea';
// ANTD
import Tabs from 'antd/lib/tabs';
import 'antd/lib/tabs/style/css';
import Dropdown from 'antd/lib/dropdown';
// COMPONENTS
import AlertsArea from './AlertsArea';
// APOLLO
import orgByUserIdQuery from 'ApolloClient/Queries/orgByUserId';
import { graphql, compose } from 'react-apollo';
// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';
import CurrencyHelpers from 'lib/helpers/CurrencyHelpers';
import StripeChecker from './StripeChecker';
import DropdownMenu from './DropdownMenu';

const SIDER_MENU_ITEMS = [
  {
    key: 'studio',
    icon: 'home',
    label: 'Edit Studio',
  },
  {
    key: 'alerts',
    icon: 'home',
    label: 'Alerts',
  },
  {
    key: 'invites',
    icon: 'home',
    label: 'Invites',
  },
  {
    key: 'payments',
    icon: 'home',
    label: 'Payments',
  },
  {
    key: 'question-templates',
    icon: 'home',
    label: 'Question Templates',
  },
  {
    key: 'email-templates',
    icon: 'home',
    label: 'Email Templates',
  },
  {
    key: 'pricing-packaging',
    icon: 'home',
    label: 'Pricing & Packaging',
  },
];

const { TabPane } = Tabs;

const StyledTabPane = styled(TabPane)`
  padding: ${p => p.theme.padding}px;
`;

class AppStudio extends React.PureComponent {
  state = {
    showContent: SIDER_MENU_ITEMS[0],
  };

  render() {
    const { orgByUserId } = this.props.orgByUserIdQuery;

    if (!orgByUserId || !orgByUserId._id) {
      return <NoStudioModal />;
    }

    let currencySymbol = CurrencyHelpers.getCurrencySymbol(orgByUserId.currency);

    if (this.props.windowWidth < 768) {
      return (
        <div>
          <div>
            <Dropdown
              overlay={
                <DropdownMenu
                  menuItems={SIDER_MENU_ITEMS}
                  onChange={content => {
                    this.setState({ showContent: SIDER_MENU_ITEMS.filter(item => item.key === content.key)[0] });
                  }}
                />
              }
              trigger={['click']} // <React.Fragment>
            >
              <div
                style={{
                  width: '100%',
                  height: 50,
                  marginBottom: 20,
                  background: '#efefef',
                  border: '1px solid #ddd',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <div style={{ fontSize: 18, margin: 8 }}>
                  <Icon type="down" style={{ margin: 6, fontSize: 12 }} />
                  <strong>{this.state.showContent.label}</strong>
                </div>
                {/*  */}
              </div>
            </Dropdown>
          </div>
          <div style={{ padding: 5 }}>
            {this.state.showContent.key === 'studio' && (
              <StudioFormArea studio={this.props.orgByUserIdQuery.orgByUserId} />
            )}
            {this.state.showContent.key === 'payments' && <PaymentsArea {...this.props} />}
            {this.state.showContent.key === 'invites' && (
              <React.Fragment>
                <ContactSettingsArea organization={this.props.currentUser.organization} />
                <InviteArea currentUser={this.props.currentUser} />
              </React.Fragment>
            )}
            {this.state.showContent.key === 'question-templates' && <QuestionTemplatesArea />}
            {this.state.showContent.key === 'pricing-packaging' && (
              <PricingAndPackagingArea currencySymbol={currencySymbol} currentUser={this.props.currentUser} />
            )}
            {this.state.showContent.key === 'integrations' && <IntegrationsArea currentUser={this.props.currentUser} />}
            {this.state.showContent.key === 'sessions' && <SessionTypesArea {...this.props} />}
            {this.state.showContent.key === 'email-templates' && <EmailTemplatesArea {...this.props} />}
            {this.state.showContent.key === 'alerts' && <AlertsArea {...this.props} />}
            <StripeChecker {...this.props} />
          </div>
        </div>
      );
    }

    return (
      <div key="1">
        <Tabs tabPosition={this.props.windowWidth > 748 ? 'left' : 'top'}>
          <StyledTabPane tab="Studio Settings" key="1">
            <StudioFormArea studio={this.props.orgByUserIdQuery.orgByUserId} />
          </StyledTabPane>
          <StyledTabPane tab="Payments" key="2">
            <PaymentsArea {...this.props} />
          </StyledTabPane>
          <StyledTabPane tab="Contact Form" key="3">
            <ContactSettingsArea organization={this.props.currentUser.organization} />
            <InviteArea currentUser={this.props.currentUser} />
          </StyledTabPane>
          <StyledTabPane tab="Questionnaires" key="5">
            <QuestionTemplatesArea />
          </StyledTabPane>
          <StyledTabPane tab="Pricing & Packaging" key="6">
            <PricingAndPackagingArea currencySymbol={currencySymbol} currentUser={this.props.currentUser} />
          </StyledTabPane>
          <StyledTabPane tab="Integrations" key="7">
            <IntegrationsArea currentUser={this.props.currentUser} />
          </StyledTabPane>
          <StyledTabPane tab="Session Types" key="8">
            <SessionTypesArea {...this.props} />
          </StyledTabPane>
          <StyledTabPane tab="Email Templates" key="9">
            <EmailTemplatesArea {...this.props} />
          </StyledTabPane>
          <StyledTabPane tab="HeyNed Alerts" key="10">
            <AlertsArea {...this.props} />
          </StyledTabPane>
        </Tabs>
        <StripeChecker {...this.props} />
      </div>
    );
  }
}

let options = props => ({
  variables: {
    _id: props.match.params._id,
  },
});

export default compose(
  graphql(orgByUserIdQuery, { options, name: 'orgByUserIdQuery' }),
  RecomposeHelpers.errorHOC({ propName: 'orgByUserIdQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'orgByUserIdQuery' }),
)(windowSize(AppStudio));



// WEBPACK FOOTER //
// ./src/routes/app-studio/index.js